import { Route, Routes } from "react-router-dom";

import { Products } from "../../pages/Products";

export const ProductsLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<Products />} />
    </Routes>
  );
};
